import { Component, OnInit, Input } from '@angular/core';
import { ContactService } from '../serv/contact.service';
import { NgForm } from '@angular/forms';
import { Route } from '@angular/compiler/src/core';
import { Router } from '@angular/router';
import { PopupService } from '@ng-bootstrap/ng-bootstrap/util/popup';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  @Input() contact = { name: 'Get in Touch', p: ' If You have any query, Please feel free to ask me anything.I ll be more than happy to provide you an answer and my services.' };
  email: string;
  constructor(private contactService: ContactService, private router: Router) { }

  save(f: NgForm) {
    if (f.valid) {
      this.contactService.createContact(f.value);
      alert("Your message has been successfully relayed. thanks \n Votre message a été envoyé avec succès. Merci ");
      f.reset();
    } else { alert("please fill in all mandatory fields \nVeuillez remplir tous les champs obligatoires  " )}
  }


  ngOnInit() {
  }

}
